/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Pricing_Trial_HeadlineInputs */

const tr_pricing_trial_headline = /** @type {(inputs: Pricing_Trial_HeadlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} Gün Ücretsiz Deneyin`)
};

const en_pricing_trial_headline = /** @type {(inputs: Pricing_Trial_HeadlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Try free for ${i?.days} days`)
};

const de_pricing_trial_headline = /** @type {(inputs: Pricing_Trial_HeadlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.days} Tage kostenlos testen`)
};

const ru_pricing_trial_headline = /** @type {(inputs: Pricing_Trial_HeadlineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Попробуйте бесплатно ${i?.days} дней`)
};

/**
* | output |
* | --- |
* | "Try free for {days} days" |
*
* @param {Pricing_Trial_HeadlineInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_trial_headline = /** @type {((inputs: Pricing_Trial_HeadlineInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Trial_HeadlineInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_trial_headline(inputs)
	if (locale === "de") return de_pricing_trial_headline(inputs)
	if (locale === "ru") return ru_pricing_trial_headline(inputs)
	return tr_pricing_trial_headline(inputs)
});